import React from 'react'
import { BackendSystemType } from './backend-system-item'
import { css } from '@emotion/css'
import { theme } from '../../styled/theme'
import { FormattedMessage } from 'react-intl'

type BackendSystemsI18n = Record<BackendSystemType, string>

const backendSystemsI18n: BackendSystemsI18n = {
  db: 'title_dataBase',
  ws: 'title_applicationFlowMap_webServiceResource',
  ldap: 'title_lightweightDirectoryAccessProtocol_abbreviation'
}

interface BackendSystemsItemTooltipContentProps {
  readonly systemType: BackendSystemType
  readonly location: string
  readonly vendorName?: string
}

export function BackendSystemItemTooltipContent({
  systemType,
  location,
  vendorName
}: BackendSystemsItemTooltipContentProps) {
  return (
    <div
      className={css`
        display: flex;
        min-width: 220px;
        flex-direction: column;
        overflow-wrap: break-word;
      `}
    >
      <div
        className={css`
          margin-bottom: 8px;
          font-size: 14px;
          font-weight: ${theme.fontWeights.primary.bold};
        `}
      >
        <FormattedMessage id={backendSystemsI18n[systemType]} />
      </div>
      <ul
        className={css`
          padding-left: 16px;
        `}
      >
        <li
          className={css`
            margin-bottom: 4px;
          `}
        >
          {location}
        </li>
        {!!vendorName && <li>{vendorName}</li>}
      </ul>
    </div>
  )
}
